const NAME = 'PLAN_SUBSCRIPTIONS_BULK_CREATE';

export const UPDATE_START_DATE = `${NAME}/UPDATE_START_DATE`;
export const UPDATE_END_DATE = `${NAME}/UPDATE_END_DATE`;
export const UPDATE_REFERENCE = `${NAME}/UPDATE_REFERENCE`;
